import React from "react";
import { LinearProgress } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomLinearProgressChart = styled(LinearProgress)(
  ({ theme, value }) => ({
    height: 15,
    borderRadius: 10,
    // backgroundColor: "#fff",
    backgroundColor: "#d2d3d7ff",
    "& .MuiLinearProgress-bar": {
      borderRadius: 10,
      backgroundColor: "#4caf50", // Green color matching the image
    },
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: "#4caf50",
    },
  })
);

const CustomLinearProgress = ({ value }) => {
  return (
    <div className="w-[100px] relative">
      <CustomLinearProgressChart variant="determinate" value={value} />
      <h2 className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-black font-semibold text-xs">
        {`${Math.round(value)}%`}
      </h2>
    </div>
  );
};

export default CustomLinearProgress;
